import { render } from "./InicioProveedoresPDV.vue?vue&type=template&id=7cab7b17&scoped=true"
import script from "./InicioProveedoresPDV.vue?vue&type=script&lang=js"
export * from "./InicioProveedoresPDV.vue?vue&type=script&lang=js"

import "./InicioProveedoresPDV.vue?vue&type=style&index=0&id=7cab7b17&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cab7b17"]])

export default __exports__